import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Info } from '@mui/icons-material';

/**
 * MockDataIndicator Component
 * Displays a visual indicator when mock/demo data is being used
 *
 * @param {boolean} isMock - Whether the data being displayed is mock data
 * @param {string} position - Position of the indicator: 'inline' | 'badge' | 'chip'
 * @param {string} size - Size of the indicator: 'small' | 'medium'
 */
const MockDataIndicator = ({
  isMock = false,
  position = 'chip',
  size = 'small',
  tooltipText = 'This data is mock/demo data. Real data will be loaded when API is available.'
}) => {
  if (!isMock) return null;

  const chipStyles = {
    small: {
      height: '20px',
      fontSize: '0.7rem',
      padding: '0 6px'
    },
    medium: {
      height: '24px',
      fontSize: '0.75rem',
      padding: '0 8px'
    }
  };

  switch (position) {
    case 'inline':
      return (
        <Tooltip title={tooltipText} arrow>
          <span style={{
            color: '#ff9800',
            fontSize: size === 'small' ? '0.7rem' : '0.75rem',
            fontWeight: 600,
            marginLeft: '8px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            cursor: 'help'
          }}>
            <Info style={{ fontSize: '14px' }} />
            (mock)
          </span>
        </Tooltip>
      );

    case 'badge':
      return (
        <Tooltip title={tooltipText} arrow>
          <div style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            backgroundColor: '#ff9800',
            color: 'white',
            padding: '2px 8px',
            borderRadius: '12px',
            fontSize: '0.7rem',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            cursor: 'help',
            zIndex: 10
          }}>
            <Info style={{ fontSize: '12px' }} />
            MOCK
          </div>
        </Tooltip>
      );

    case 'chip':
    default:
      return (
        <Tooltip title={tooltipText} arrow>
          <Chip
            icon={<Info style={{ fontSize: '14px' }} />}
            label="MOCK DATA"
            size={size}
            sx={{
              backgroundColor: '#fff3e0',
              color: '#e65100',
              borderColor: '#ff9800',
              border: '1px solid',
              fontWeight: 600,
              ...chipStyles[size],
              '& .MuiChip-icon': {
                color: '#e65100',
                fontSize: '14px'
              }
            }}
          />
        </Tooltip>
      );
  }
};

export default MockDataIndicator;
